<!-- 搜索组件 -->
<template>
  <div>
    <slot name="extra"></slot>

    <div class="search-content">
      <template v-for="(item, index) in fieldList">
        <div v-show="icon === 'close' ? index < count : true" :key="index">
          <div v-show="!item.itemHidden" class="item-style">
            <el-tooltip
              v-if="item.label.length > 10"
              :content="item.label"
              placement="top"
            >
              <span
                class="label-style ellipsis"
                :style="{ width: width.labelWidth + 'px', height: '13px' }"
              >
                {{ item.label }}:
              </span>
            </el-tooltip>

            <div
              v-else
              class="label-style"
              :style="{ width: width.labelWidth + 'px', height: '13px' }"
            >
              <span style="font-size: 14px">{{ item.label }}</span>
              <el-tooltip v-if="item.labelTooltip" placement="top">
                <div slot="content">
                  <p>{{ item.labelTooltipContent }}</p>
                </div>
                <span class="right-icon">?</span>
              </el-tooltip>
              <span style="font-size: 14px">:</span>
            </div>

            <!-- <span v-else class="label-style" :style="{ width: width.labelWidth + 'px', height: '13px' }">
              {{ item.label }}:
            </span> -->
            <!-- 只允许输入数字的输入框 -->
            <el-input
              v-if="item.type === 'inputnumber'"
              ref="refInput"
              v-model.trim="defaultData[item.value]"
              :size="size"
              :style="{ width: width.itemWidth + 'px' }"
              :type="item.type == 'inputnumber' ? 'input' : ''"
              :disabled="item.disabled"
              :placeholder="getPlaceholder(item)"
              oninput="value=value.replace(/[^0-9]/g, '')"
              @keyup.enter.native="handleFilter"
              @blur="handleEvent($event, item.value)"
            />
            <!-- 普通输入框 -->
            <el-input
              v-if="item.type === 'input'"
              v-model.trim="defaultData[item.value]"
              :size="size"
              :style="{ width: width.itemWidth + 'px' }"
              :type="item.type"
              :value="defaultData[item.value]"
              :disabled="item.disabled"
              :placeholder="getPlaceholder(item)"
              @input="handleInput"
              @keyup.enter.native="handleFilter"
              @blur="handleEvent($event, item.value)"
            />

            <!-- 弹框 -->
            <el-input
              v-if="item.type === 'dialog'"
              ref="refInput"
              v-model.trim="defaultData[item.value]"
              :size="size"
              :style="{ width: width.itemWidth + 'px' }"
              :type="item.type"
              :disabled="item.disabled"
              :placeholder="getPlaceholder(item)"
              @focus="handleFocus($event, item.value)"
              @keyup.enter.native="handleFilter"
              @blur="handleEvent($event, item.value)"
            />
            <!-- 日期/时间 -->
            <el-date-picker
              v-if="item.type === 'date'"
              v-model="defaultData[item.value]"
              :size="size"
              :unlink-panels="true"
              :style="{ width: width.itemWidth + 'px' }"
              :type="item.dateType"
              :picker-options="item.TimePickerOptions"
              :clearable="item.clearable"
              :disabled="item.disabled"
              :default-time="item.defaultTime"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :placeholder="getPlaceholder(item)"
              :value-format="item.valueFormat"
              @change="handleEvent($event, item.value, 'change')"
            />
            <!-- 选择框 -->
            <el-select
              v-if="item.type === 'select'"
              ref="search"
              v-model.trim="defaultData[item.value]"
              :collapse-tags="item.collapseTags"
              :size="size"
              :style="{ width: width.itemWidth + 'px' }"
              :disabled="item.disabled"
              :clearable="item.clearable"
              :filterable="item.filterable"
              :multiple="item.multiple"
              :remote="item.remote"
              :reserve-keyword="item.reserveKeyword"
              :loading="item.loading"
              :placeholder="getPlaceholder(item)"
              :remote-method="item.remoteMethod"
              @change="handleEvent($event, item.value, 'change')"
            >
              <el-option
                v-for="(childItem, index) in listTypeInfo[item.list]"
                :key="index"
                :label="childItem.name"
                :value="childItem.id"
                :disabled="childItem.disabled"
              />
            </el-select>
            <!-- 计数器 -->
            <el-input-number
              v-if="item.type === 'inputNumber'"
              v-model="defaultData[item.value]"
              :size="size"
              :style="{ width: width.itemWidth + 'px' }"
              :min="item.min"
              :max="item.max"
              @change="handleEvent($event, item.value, 'change')"
            />
            <!-- 单选 -->
            <el-radio-group
              v-if="item.type === 'radio'"
              v-model="defaultData[item.value]"
            >
              <el-radio
                v-for="childItem in listTypeInfo[item.list]"
                :key="childItem.id"
                :label="childItem.id"
              >
                {{ childItem.name }}
              </el-radio>
            </el-radio-group>
            <!-- 带提示搜索框 -->
            <el-autocomplete
              v-if="item.type === 'autocomplete'"
              :key="index"
              v-model="defaultData[item.value]"
              class="inline-input"
              :fetch-suggestions="handleSuggestions"
              :placeholder="getPlaceholder(item)"
              :trigger-on-focus="false"
              @input="handleInput"
              @blur="handleEvent($event, item.value)"
              @focus="handleFocus($event, item)"
              @select="handleSelect"
            ></el-autocomplete>
            <!-- 级联 -->
            <el-cascader
              v-if="item.type === 'cascader'"
              v-model="defaultData[item.value]"
              :style="{ width: width.itemWidth + 'px' }"
              :placeholder="item.placeholder"
              :options="listTypeInfo[item.list]"
              :props="item.props"
              :filterable="item.filterable"
              collapse-tags
              @change="handleEvent($event, item.value, 'change')"
            ></el-cascader>
            <!-- 区间输入框 -->
            <div v-if="item.type === 'numRange'" style="display: inline-block">
              <el-input
                v-model="defaultData[item.value1]"
                placeholder="请输入"
                type="number"
                :style="{
                  width: item.rangeWidth ? '98px' : width.itemWidth + 'px',
                }"
                :size="size"
              ></el-input>
              <span style="margin: 0 10px">-</span>
              <el-input
                v-model="defaultData[item.value2]"
                type="number"
                placeholder="请输入"
                :style="{
                  width: item.rangeWidth ? '98px' : width.itemWidth + 'px',
                }"
                :size="size"
              ></el-input>
            </div>
          </div>
        </div>
      </template>
      <div v-if="!btnHidden && fieldList.length !== 0" class="btn-style">
        <!-- <div class="btn-reset" >{{ btnStyle[0].text }}</div>
      <div class="btn-search">{{ btnStyle[1].text }}</div>-->
        <!-- <el-button
          :type="btnStyle[0].type"
          :size="size"
          :plain="btnStyle[0].plain"
          :round="btnStyle[0].round"
          :icon="btnStyle[0].icon"
          :disabled="btnStyle[0].disabled"
          @click="handleReset"
          >{{ btnStyle[0].text }}</el-button
        > -->
        <eui-btn
          style="margin-right: 20px"
          type="secondary"
          :plain="btnStyle[0].plain"
          :round="btnStyle[0].round"
          :icon="btnStyle[0].icon"
          :disabled="btnStyle[0].disabled"
          @click="handleReset"
        >
          {{ btnStyle[0].text }}
        </eui-btn>
        <eui-btn
          type="weak"
          :plain="btnStyle[1].plain"
          :round="btnStyle[1].round"
          :disabled="btnStyle[1].disabled"
          :icon="btnStyle[1].icon"
          @click="handleFilter"
        >
          {{ btnStyle[1].text }}
        </eui-btn>
        <!-- <el-button
          :type="btnStyle[1].type"
          :size="size"
          :plain="btnStyle[1].plain"
          :round="btnStyle[1].round"
          :disabled="btnStyle[1].disabled"
          :icon="btnStyle[1].icon"
          @click="handleFilter"
          class="check-btn"
          >{{ btnStyle[1].text }}</el-button
        > -->
        <eui-btn
          v-if="btnStyle.length == 3"
          type="weak"
          :plain="btnStyle[2].plain"
          :round="btnStyle[2].round"
          :disabled="btnStyle[2].disabled"
          :icon="btnStyle[2].icon"
          @click="handleExport"
        >
          {{ btnStyle[2].text }}
        </eui-btn>
        <!-- <el-button
          v-if="btnStyle.length == 3"
          :type="btnStyle[2].type"
          :size="size"
          :plain="btnStyle[2].plain"
          :round="btnStyle[2].round"
          :disabled="btnStyle[2].disabled"
          :icon="btnStyle[2].icon"
          @click="handleExport"
          class="check-btn"
          >{{ btnStyle[2].text }}</el-button
        > -->
      </div>
      <el-button
        v-if="fieldList.length > count"
        type="text"
        style="margin-left: 6px"
        @click="icon === 'open' ? (icon = 'close') : (icon = 'open')"
      >
        {{ icon === 'open' ? '收起' : '展开' }}
        <i
          :class="
            icon === 'open' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
          "
        />
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ESearch',
  props: {
    /** 字段默认数据 */
    data: {
      type: Object,
      default: () => {},
      required: true,
    },
    /** 字段配置项 */
    fieldList: {
      type: Array,
      default: () => [],
      required: true,
    },
    /** 相关的列表 */
    listTypeInfo: {
      type: Object,
      default: () => {},
    },
    /** 按钮区域是否隐藏 */
    btnHidden: {
      type: Boolean,
      default: false,
    },
    /** 组件尺寸 */
    size: {
      type: String,
      default: 'mini',
    },
    /** 默认搜索数 */
    count: {
      type: Number,
      default: 10,
    },
    /** 组件及label宽度 */
    width: {
      type: Object,
      default: () => ({
        labelWidth: 110,
        itemWidth: 220,
      }),
    },
    /** 按钮配置 */
    btnStyle: {
      type: Array,
      default: () => [
        {
          icon: null,
          text: '重置',
          disabled: false,
          type: null,
          plain: false,
          round: false,
        },
        {
          icon: null,
          text: '查询',
          disabled: false,
          type: 'primary',
          plain: false,
          round: false,
        },
      ],
    },
  },
  data: () => ({
    defaultData: {},
    icon: 'close',
  }),
  watch: {
    data: {
      handler(newVal) {
        this.defaultData = { ...newVal };
      },
      deep: true,
    },
  },
  mounted() {
    /**
     * 子组件无法直接修改父组件传递过来的值
     * 于是将父组件传递的值首先赋值给 defaultData
     * 在搜索条件中同样使用 defaultData
     * 永远保持 props 传递的 data 纯洁度
     */
    this.defaultData = { ...this.data };
  },
  methods: {
    remoteMethod(row) {
      this.$emit('remoteMethod', row);
    },
    /**
     * @func 占位符显示
     * @param {Object} row
     * @desc 📝
     */
    getPlaceholder(row) {
      let placeholder;
      if (row.placeholder) {
        return row.placeholder;
      }
      if (row.type === 'input') {
        placeholder = `请输入${row.label}`;
      } else if (
        row.type === 'select' ||
        row.type === 'time' ||
        row.type === 'date'
      ) {
        placeholder = `请选择${row.label}`;
      } else {
        placeholder = row.label;
      }
      return placeholder;
    },
    /**
     * @func 事件处理
     * @desc 📝
     */
    handleEvent(event, val, change) {
      const obj = {
        value: change === 'change' ? event : event.target.value,
        label: val,
      };
      this.$emit('handleEvent', obj);
      // console.log(val, event, change);
    },

    /**
     * @func input事件
     * @desc 📝
     */
    handleInput(el) {
      this.$emit('handleInput', el);
    },

    /**
     * @func 带提示搜索框
     * @desc 📝
     */
    handleSuggestions(queryString, cb) {
      const val = {
        queryString,
        cb,
      };
      this.$emit('handleSuggestions', val);
    },
    handleFocus(ev, item) {
      const obj = {
        ev,
        item,
      };
      this.$emit('handleFocus', obj);
    },

    handleSelect(item) {
      this.$emit('handleSelect', item);
    },

    /**
     * @func 搜索
     * @desc 📝
     */
    handleFilter() {
      this.$emit('handleFilter', this.defaultData);
    },
    /**
     * @func 重置
     * @desc 📝
     */
    handleReset() {
      this.defaultData = { ...this.data };
      this.$emit('handleReset', this.defaultData);
    },
    /**
     * @func 导出
     * @desc 📝
     */
    handleExport() {
      this.defaultData = { ...this.data };
      this.$emit('handleExport', this.defaultData);
    },
  },
};
</script>
<style lang="scss" scoped>
.search-content {
  // width: 1149px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  // overflow-y: auto;
}
.search-content .item-style {
  margin: 0px 20px 10px auto;
  line-height: 1;
  .min-width {
    width: 98px;
  }
}
.search-content .item-style .label-style {
  display: inline-block;
  justify-self: end;
  font-size: 0;
  // white-space: wrap;
  //overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  text-align: right;
  margin-right: 12px;
  color: #333;
}
.btn-style {
  // margin: 6px 0 6px auto;
  // display: flex;
  // flex-wrap: wrap;
  width: 100%;
  text-align: center;
  // margin-top: 10px;
}
.btn-reset {
  width: 80px;
  height: 30px;
  line-height: 28px;
  border: 1px solid #d9d9d9;
  color: #333;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  margin-right: 30px;
}
.btn-search {
  width: 80px;
  height: 30px;
  line-height: 28px;
  border: 1px solid #ffbd00;
  color: #ea9200;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.el-radio-group {
  line-height: 35px;
  height: 28px;
  .el-radio {
    margin-right: 5px;
    .el-radio__label {
      padding-left: 5px;
    }
  }
}

.el-input {
  height: 30px;
}
.item-style::v-deep .el-input__inner {
  height: 30px;
  line-height: 30px;
  border-radius: 0;
}
.el-button {
  border-radius: 0;
  width: 80px;
  height: 30px;
  padding: 0;
  font-size: 14px;
}
.check-btn::v-deep.el-button {
  border: 1px solid #2587ff;
  background: #fff;
  color: #2587ff;
  margin-left: 30px;
}
.check-btn::v-deep.el-button:hover {
  // border:1px solid #2587FF;
  background: #e8efff;
  // color: #2587FF;
  text-decoration: none;
}
::v-deep.el-button:hover {
  // border:1px solid #2587FF;
  background: #e8efff;
  // color: #2587FF;
  text-decoration: none;
}
.right-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-left: 4px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  font-size: 12px;
  color: #c5c5c5;
  cursor: pointer;
  &:hover {
    background: #c5c5c5;
    color: #fff;
  }
}
</style>
